var Menu = {};

jQuery(document).ready(function ($) {
    var self = null;

    Menu = {

        init: function () {
            self = this;
            this.initMenu();
            this.scrollMenu();
        },

        initMenu: function () {
            $('.toggle-menu').on('click', function () {
                $('.custom-menu').toggleClass('show');
            });

            $('nav.menu a').on('click', function () {
                $('.custom-menu').removeClass('show');
            })
        },

        scrollMenu: function () {
            $(window).scroll(function () {
                var scroll = $(window).scrollTop();

                if (scroll >= 50) {
                    $(".home #site-menu").addClass("dark-header");
                    $("#site-menu").addClass("scrolled-header");
                } else {
                    $(".home #site-menu").removeClass("dark-header");
                    $("#site-menu").removeClass("scrolled-header");
                }
            });
        }
    };
});
